// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-grid-list__item__title{margin-bottom:1rem;text-decoration:none}.czt-grid-list__item>.czt-link:hover{text-decoration:none !important}.czt-link:hover .czt-grid-list__item__title{text-decoration:underline !important;text-decoration-color:inherit}.czt-grid-list__item__image{margin-bottom:2rem;max-width:50px !important}", ""]);
// Exports
module.exports = exports;
